<template>
  <div class="contentPadding">
    <a-form layout="inline" :model="listQuery" style="margin-bottom:20px;">
      <a-form-item label="标签名称">
        <a-input
          placeholder="请输入"
          v-model:value="listQuery.labName"
          allowClear
        />
      </a-form-item>
      <a-form-item label="上级标签">
        <a-select
          v-model:value="listQuery.parentId"
          style="width:200px;"
          show-search
          option-filter-prop="label"
          :filter-option="filterOption"
          allowClear
        >
          <a-select-option value="">全部</a-select-option>
          <!-- <a-select-option value="">一级标签</a-select-option> -->
          <a-select-option
            v-for="(item,index) in tabAllList"
            :value="item.id"
            :key="index"
            >{{ item.labName+'' }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="handleSearch"> 查询 </a-button>
      </a-form-item>

      <a-form-item>
        <a-button @click="handleAllReset"> 重置 </a-button>
      </a-form-item>
    </a-form>
    <a-row class="buttonGroup">
      <a-button
        type="primary"
        @click="handleAdd"
        v-if="isShowBtn('sys:syslab:save')"
        ><PlusOutlined /> 新增
      </a-button>
    </a-row>
    <a-table
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      row-key="id"
      @change="changeTable"
    >
      <a-table-column key="loginName" title="序号" data-index="loginName">
        <template v-slot="scope">
          {{
            (Number(pagination.current) - 1) * Number(pagination.pageSize) +
              scope.index +
              1
          }}
        </template>
      </a-table-column>
      <a-table-column
        key="labName"
        title="标签名称"
        data-index="labName"
        :ellipsis="true"
      />
      <a-table-column
        key="deleted"
        title="状态"
        data-index="deleted"
        :ellipsis="true"
      >
        <template v-slot="scope">
          <span v-if="scope.record.deleted === 1">正常</span>
          <span v-if="scope.record.deleted === 0">禁用</span>
        </template>
      </a-table-column>
      <a-table-column
        key="attention"
        title="热度"
        data-index="attention"
        :ellipsis="true"
      />
      <a-table-column
        key="parentName"
        title="上级标签"
        :ellipsis="true"
      >
      <template v-slot="scope">
          <span>
            {{scope.record.parentName}}
          </span>
      </template>
      </a-table-column>
      <a-table-column
        key="remark "
        title="简介"
        data-index="remark"
        :ellipsis="true"
      />
      <!-- <a-table-column
        key="createTime"
        title="创建时间"
        data-index="createTime"
      /> -->
      <a-table-column key="action" title="操作" width="220px" align="center">
        <template v-slot="scope">
          <span>
            <a-button type="link" @click="handleShow(scope.record)">
              查看
            </a-button>
            <a-button
              type="link"
              @click="handleEdit(scope.record)"
              v-if="isShowBtn('sys:syslab:update')"
            >
              修改
            </a-button>
            <a-button
              type="link"
              @click="handleDel(scope.record)"
              v-if="isShowBtn('sys:syslab:delete')"
            >
              删除
            </a-button>
          </span>
        </template>
      </a-table-column>
    </a-table>
    <!-- 添加、修改modal -->
    <a-modal
      :title="title"
      v-model:visible="showModal"
      :maskClosable="false"
      :footer="null"
      :centered="true"
      @cancel="handleCancle"
      style="min-width: 800px"
    >
    
      <a-form
        :labelCol="{ span: 4, offset: 0 }"
        :wrapperCol="{ span: 18, offset: 0 }"
        ref="labForm"
        :model="tabInfo"
        :rules="rules"
        
      >
        <a-form-item label="标签名称" name="labName">
          <a-input v-model:value="tabInfo.labName" placeholder="请输入标签名称" :disabled="isShow" />
        </a-form-item>
        <a-form-item
          label="标签图片"
          name="subjectInfo"
        >
          <div class="clearfix">
            <a-upload
              list-type="picture-card"
              :file-list="imgUrl"
              :customRequest="customRequestZip"
              :before-upload="beforeUploadZip"
              @preview="handlePreview"
              :remove="removeFile"
               :disabled="isShow"
            >
              <div v-if="imgUrl !== null && imgUrl.length < 1">
                <plus-outlined />
                <div class="ant-upload-text">上传图片</div>
              </div>
            </a-upload>
            <a-modal
              :visible="imgVisible"
              :footer="null"
              :keyboard="true"
              :maskClosable="true"
              @cancel="showImg"
            >
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
          
        </a-form-item>
        <a-form-item label="简介" name="remark">
          <a-textarea
            v-model:value="tabInfo.remark"
            placeholder="非必填"
            type="textarea"
            :maxlength="100"
            :showCount="true"
            allow-clear
            :disabled="isShow"
          ></a-textarea>
        </a-form-item>
        <a-form-item label="上级标签" v-show="!isShow">
          <a-select
          v-model:value="tabValue"
            @change="changTab"
            show-search
            option-filter-prop="label"
            :filter-option="filterOption"
            :disabled="isShow"
          >
            <a-select-option
              v-for="(item,index) in tabAllList"
              :key="index"
              :value="item.id"
              placeholder="请选择标签(可搜索)"
              >{{ item.labName+'' }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          :label="isShow?'上级标签':'已选标签'"
          v-if="tabArr !== null && tabArr.length > 0"
        >
          <span v-for="item in tabArr" :key="item.parentId">
            <a-tag :closable="!isShow" @close="preventDefault(item)">
              {{ item.labName }}
            </a-tag>
          </span>
        </a-form-item>
        
        
        <a-form-item
          label="初始点击量"
          name="initNumber"
        >
        <a-input-number v-model:value="tabInfo.initNumber" :min="0" :precision="0" :disabled="isShow" allow-clear />
        </a-form-item>
        <a-form-item label="相关标签" v-show="!isShow">
          <a-select
          v-model:value="tabValue1"
            @change="changTab1"
            show-search
            option-filter-prop="label"
            :filter-option="filterOption"
            :disabled="isShow"
          >
          <!-- <a-select-option :value="-1">一级标签</a-select-option> -->
            <a-select-option
              v-for="(item,index) in tabAllList1"
              :key="index"
              :value="item.id"
              placeholder="请选择标签(可搜索)"
              >{{ item.labName+'' }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item 
        :label="isShow?'相关标签':'已选标签'"
          v-if="tabArr1 !== null && tabArr1.length > 0"
        >
          <span v-for="item in tabArr1" :key="item.relevanceLabId">
            <a-tag :closable="!isShow" @close="preventDefault1(item)">
              {{ item.labName }}
            </a-tag>
          </span>
        </a-form-item>
        <a-form-item label="状态" name="deleted">
          <a-select
            v-model:value="tabInfo.deleted"
            style="width:200px;"
            :disabled="isShow"
          >
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="是否以频道展示">
          <a-switch checked-children="是" un-checked-children="否" v-model:checked="tabInfo.channelShow" :disabled="isShow"/>
        </a-form-item>
        <a-form-item label="标签类型" name="type">
          <a-select
            v-model:value="tabInfo.type"
            style="width:200px;"
            :disabled="isShow"
            @change="changeType"
          >
            <a-select-option :value="1">公司标签</a-select-option>
            <a-select-option :value="0">普通标签</a-select-option>
            <a-select-option :value="2">内容标签</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="公司全称" name="companyName" v-show="showCompany">
          <a-input v-model:value="tabInfo.companyName" placeholder="请输入公司全称" :disabled="isShow" />
        </a-form-item>
        <a-form-item label="注册时间" v-show="showCompany">
          <a-date-picker v-model:value="tabInfo.comCreateTime" ormat="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD" placeholder="请选择注册日期" :disabled="isShow" :disabledDate="disabledDate" @change="onChangePush" />
        </a-form-item>
        <a-form-item label="注册资本" v-show="showCompany">
          <a-row>
            <a-col>

            <a-input-number v-model:value="investments" :min="1" :max="9999" :disabled="isShow" />
            </a-col>
            <a-col>
              <a-select
            v-model:value="Measure"
            :disabled="isShow"
            @change="measureChange"
            width="200"
          >
            <a-select-option :value="1">元</a-select-option>
            <a-select-option :value="10000">万元</a-select-option>
            <a-select-option :value="100000000">亿元</a-select-option>
          </a-select>
            </a-col>
          
          </a-row>
          

        </a-form-item>
        <a-form-item :wrapper-col="{ span: 14, offset: 9 }">
          <a-button type="primary" @click="handleSave" v-if="!isShow">
            保存
          </a-button>
          <a-button
            style="margin-left: 10px;"
            @click="handleCancle"
            v-if="!isShow"
          >
            取消
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
/**
 * author:ut002528
 * effect：标签管理
 * date: 2021/07/30
**/
import { PlusOutlined } from "@ant-design/icons-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { createVNode } from "vue";
import { Modal, notification } from "ant-design-vue";
import { isShowBtn } from "@/until/tool";
import { getAttachmentCode,deleteAttachment,getAttachmentList } from "@/api/news";
import html2canvas from "html2canvas"
import moment from "moment";
export default {
  data() {
    const partnerTypeId = async (rule, value) => {
      if (value === "" || !value) {
        return Promise.reject("请选择新闻订阅标签类型");
      } else {
        return Promise.resolve();
      }
    };
    const checkDocTitle = async (rule, value) => {
      if (value.length > 9) {
        return Promise.reject("标签长度能超过9个汉字或字母");
      } else if (value.length <= 0){
        return Promise.reject("标签名称必填");
      }else{
        return Promise.resolve();
      }
    };
    const checkDocTitle1 = async (rule, value) => {
      if(!this.isShow && this.showCompany){
        if (value.length > 21) {
        return Promise.reject("公司全称长度能超过21个汉字或字母");
      } else if (value.length <= 0){
        return Promise.reject("公司全称必填");
      }else{
        return Promise.resolve();
      }
      }
      
    };
    return {
      Measure:1,
      tabValue:"",
      tabValue1:"",
      title: "",
      rules: {
        labName: [
          { required: true, validator: checkDocTitle,type:'string' },
          {
                whitespace: true, 
                message: "不能只输入空格", 
              }
        ],
        companyName:[
          { required: true, validator: checkDocTitle1,type:'string' },
          {
                whitespace: true, 
                message: "不能只输入空格", 
              }
        ]
      },
      showModal: false, //添加、修改modal的flag
      roleList: [], //角色列表
      data: [], //列表数据
      loading: false,
      selectRowIds: "", //被选中都行
      isShow: false, //是否查看
      pagination: {
        // 分页配置器
        pageSize: 10, // 一页的数据限制
        current: 1, // 当前页
        total: 0, // 总数
        hideOnSinglePage: false, // 只有一页时是否隐藏分页器
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true, // 是否可以改变 pageSize
        pageSizeOptions: ["5", "10", "30"] // 指定每页可以显示多少条
      },
      imgCode: "",
      partnerTypeArr: [],
      investments:1,
      tabInfo: {
        channelShow:0,
        parentLabEntityList:[],
        relevanceLabEntityList:[],
        attachmentCode:'',
        labName: "",
        companyName:'',
        remark: "",
        initNumber:0,
        comCreateTime:null,
        investments:1,
        type: 0,
        registTime:'2021-7-30',
        registMount:1,
        deleted: 1
      }, //新闻订阅标签信息对象
      imgUrl: [],
      imgUrl1:[],
      acceptTypeEquipZip: ["jpg", "jpeg", "png", "gif"],
      imgVisible: false,
      previewImage: "",
      fileImgList: [],
      listQuery: {
        pageSize: 10,
        pageIndex: 1,
        labName: "",
        parentId: ""
      },
      tabAllList: [],
      tabAllList1: [],
      tabArr:[],
      tabArr1:[],
      showCompany:false,
      fileList:[]
    };
  },
  created() {
    this.getAllTabList();
    
  },
  async mounted() {
    this.getList();
  },
  watch:{
    tabInfo:{//深度监听，可监听到对象、数组的变化
         handler(val, oldVal){
          if(this.imgUrl1.length !== 0 && (val.companyName != oldVal.companyName || val.remark != oldVal.remark)){
            console.log('del',this.imgUrl1)
            this.removeAttach(this.imgUrl1[0]);
          }
         },
         deep:true //true 深度监听
     }
  },
  computed: {
    // 判断选择了哪行数据
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectRowIds = selectedRowKeys;
        }
      };
    }
  },
  methods: {
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment(new Date(), "YYYY-MM-DD");
    },
  // 把base64 转换成文件对象
  dataURLtoFile(base64Str, fileName) {
    var arr = base64Str.split(','),
    mime = arr[0].match(/:(.*?);/)[1], //base64解析出来的图片类型
    bstr = atob(arr[1]), //对base64串进行操作，去掉url头，并转换为byte   atob为window内置方法
    len = bstr.length,
    // ab = new ArrayBuffer(len), //将ASCII码小于0的转换为大于0
    u8arr = new Uint8Array(len); //
    while (len--) {
        u8arr[len] = bstr.charCodeAt(len)
    };
    // 创建新的 File 对象实例[utf-8内容，文件名称或者路径，[可选参数，type：文件中的内容mime类型]]
    return new File([u8arr], fileName, {
        type: mime
     })
},
    // 判断按钮权限
    isShowBtn,
    // 删除上传文件
    removeFile(file) {
      console.log(this.imgUrl, "imgUrl",file);
      this.removeAttach(this.imgUrl[0]);
      this.imgUrl = [];
    },
    async removeAttach(data) {
      await deleteAttachment(data.id)
        .then(() => {
          message.success("删除成功");
          this.fileList.splice(data.index, 1);
        })
        .catch(() => {
          message.error("删除失败");
        });
    },
    // 文件上传前的格式验证 zip
    beforeUploadZip(file) {
      this.fileImgList = [...this.fileImgList, file];
      const uploadSize = file.size / 1024 / 1024 < 50;
      const uploadType = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (
        this.acceptTypeEquipZip.length > 0 &&
        this.acceptTypeEquipZip.indexOf(uploadType) === -1
      ) {
        this.$message.error(
          "导入文件只能是" + this.acceptTypeEquipZip.join("、") + "格式!"
        );
        return false;
      }
      if (!uploadSize) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return false;
      }
    },
        // 上传 zip
    customRequestZip(data) {
      console.log('data1',data.file)
      this.showUploadMessage = true;
      this.uploadLoadingFlag = true;
      this.secModalFlag = true;
      const formData = new FormData();
      formData.append("file", data.file);
      console.log('this.tabInfo.attachmentCode',this.tabInfo.attachmentCode)
      formData.append("attachmentCode", this.tabInfo.attachmentCode);
      formData.append("readType", "public");
      // formData.append("token", "aiufpaidfupipiu"); //随便写一个token示例
      this.$store
        .dispatch("news/UploadAttachment", formData)
        .then(res => {
          if (res.code === 0) {
            // notification["success"]({
            //   message: "上传成功"
            // });
            // res.data.forEach(item => {
            //   item.url = item.ossUrl;
            // });
            res.data.name = res.data.attachmentName;
            if(res.data.ossUrl){
              res.data.url = res.data.ossUrl;
              this.tabInfo.logoURL = res.data.ossUrl;
            }
            
            this.imgUrl = [res.data];
            this.uploadMessage = res.msg;
            this.uploadSuccessFlag = "1";
          } else {
            this.uploadMessage = res.msg;
            this.$message.error("上传失败");
            this.uploadSuccessFlag = "0";
          }
          this.uploadLoadingFlag = false;
          this.secModalFlag = false;
        })
        .catch(err => {
          this.uploadLoadingFlag = false;
          this.secModalFlag = false;
          this.$message.error("调用接口失败，请联系管理员" + err);
        });
    },
    // 预览图片
    handlePreview() {
      this.imgVisible = true;
      if(this.imgUrl[0].ossUrl)
      this.previewImage = this.imgUrl[0].ossUrl;
    },
    onChangePush(e,f){
      console.log('e',e,f)
      if(e == null)
      this.tabInfo.comCreateTime = null
      else
      this.tabInfo.comCreateTime = f+' 00:00:00'
    },
    // 标签类型选择事件
    changeType(e){
      console.log('type',e)
      if(e == 1){
        this.showCompany = true
      }else{
        this.showCompany = false
      }
    },
    // 父级标签选择事件
    changTab(e) {
      this.tabAllList.forEach(item => {
        if (item.id === e && item.deleted==1) {
          if (!this.tabArr) {
            this.tabArr = [];
          }
          item.parentId = item.id
          this.tabArr.push(item);
        }
      });
      this.tabArr = this.removeArr(this.tabArr);
    },
    // 相关标签选择事件
    changTab1(e) {
      this.tabAllList1.forEach(item => {
        if (item.id === e && item.deleted==1) {
          if (!this.tabArr1) {
            this.tabArr1 = [];
          }
          item.relevanceLabId = item.id
          this.tabArr1.push(item);
        }
      });
      this.tabArr1 = this.removeArr(this.tabArr1);
    },
    // 数组去重
    removeArr(arr) {
      const res = new Map();
      return arr.filter(
        arr => !res.has(arr.labName) && res.set(arr.labName, 1)
      );
    },
     // 删除已选择标签
    preventDefault(e) {
      this.tabArr.forEach((item, index) => {
        if (item.id === e.id) {
          this.tabArr.splice(index, 1);
        }
      });
    },
     // 删除已选择标签
    preventDefault1(e) {
      this.tabArr1.forEach((item, index) => {
        if (item.id === e.id) {
          this.tabArr1.splice(index, 1);
        }
      });
    },
    // 获取所有标签不分页
    getAllTabList() {
      this.$store
        .dispatch("ListSyslab")
        .then(res => {
          if (res.code === 0) {
            this.tabAllList1 = res.data;
            this.tabAllList = res.data;
            
            res.data.forEach((item,index)=>{
              if(item.deleted == 0){
                this.tabAllList1.splice(index,1)
              }
            })
            res.data.forEach((item,index)=>{
              if(item.deleted == 0){
                this.tabAllList.splice(index,1)
              }
            })
            // console.log('res',res.data)
            
            
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 新增
    async handleAdd() {
      this.temp();
      const _this = this;
      await getAttachmentCode().then((res)=>{
        // this.attachmentCode = res
        _this.tabInfo.attachmentCode = res
        console.log('ee',this.tabInfo)
      })
      this.title = "新增订阅标签信息";
      this.isShow = false;
      this.showModal = true;
      this.imgUrl = [];
      
    },
    showImg() {
      this.imgVisible = false;
    },
    // 保存用户信息
    handleSave() {
      console.log('b',this.tabInfo)
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      const tabObj = Object.assign(self.tabInfo);
      tabObj.parentLabEntityList = this.tabArr;
      tabObj.relevanceLabEntityList = this.tabArr1;
      tabObj.investments = this.investments * this.Measure;
      if(tabObj.comCreateTime)
      tabObj.comCreateTime = tabObj.comCreateTime + ' 00:00:00'
      console.log('obj.investments % 10000;',(tabObj.investments % 10000));
      tabObj.type = Number(tabObj.type);
      tabObj.deleted = Number(tabObj.deleted);
      tabObj.attachmentCode = tabObj.attachmentCode;
      tabObj.channelShow = Number(tabObj.channelShow)
      if(!tabObj.initNumber){
        tabObj.initNumber = 0
      }
      let funStr = "";
      let msg = "";
      if (!tabObj.id) {
        funStr = "SaveSyslab";
        msg = "添加成功";
      } else {
        funStr = "UpdateSyslab";
        msg = "修改成功";
      }
      console.log('e',tabObj)
      this.$refs.labForm
        .validate()
        .then(() => {
          console.log('f',tabObj)
          self.$store
            .dispatch(funStr, tabObj)
            .then(res => {
              console.log('d',tabObj)
              if (res.code === 0) {
                notification["success"]({
                  message: msg
                });
                this.showModal = false;
                
                self.getList();
                self.getAllTabList();
                this.temp();
              } else {
                self.$handleErr(res);
              }
            })
            .catch(err => {
              self.$handleErr(err);
            });
        })
        .catch(error => {
          return false;
        });
    },
    //情况添加数据
    temp() {
      this.tabArr = [];
      this.tabArr1 = [];
      this.Measure = 1;
      this.tabValue = "";
      this.tabValue1 = "";
      this.imgUrl = [];
      this.showCompany = false
      this.investments=1
      this.tabInfo = {
        parentLabEntityList:[],
        relevanceLabEntityList:[],
        channelShow:0,
        labName: "",
        companyName:'',
        remark: "",
        initNumber:0,
        comCreateTime:null,
        investments:1,
        type: 0,
        deleted: 1
      };
    },
    // 列表
    getList() {
      this.loading = true;
      this.$store
        .dispatch("SelectListSyslab", this.listQuery)
        .then(res => {
          if (res.code === 0) {
            if (
              res.data.currPage > res.data.totalPage &&
              res.data.totalPage !== 0
            ) {
              this.listQuery.pageIndex = res.data.totalPage;
              this.getList();
            } else {
              this.listQuery.pageIndex = res.data.currPage;
            }
            this.data = res.data.list;
            this.listQuery.pageSize = res.data.pageSize;
            this.pagination.current = res.data.currPage;
            this.pagination.pageSize = res.data.pageSize;
            this.pagination.total = res.data.totalCount;
            this.loading = false;
          } else {
            this.loading = false;
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.loading = false;
          this.$handleErr(err);
        });
    },
    // 查询
    handleSearch() {
      this.listQuery.pageIndex = "1";
      this.listQuery.pageSize = this.pagination.pageSize;
      this.getList();
    },
    handleAllReset() {
      this.listQuery = {
        pageSize: 10,
        pageIndex: 1,
        key: "",
        parentId: ""
      };
    },
    // 删除
    handleDel(rowData) {
      this.$store
        .dispatch("DeleteSyslab", {"id":rowData.id})
        .then(res => {
          if (res.code === 0) {
            notification["success"]({
              message: "删除成功"
            });
            this.getList();
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    // 修改
    handleEdit(rowData) {
      console.log('rowData',rowData)
      // await getAttachmentCode().then((res)=>{
      //   this.attachmentCode = res
      // })
      this.title = "修改新闻订阅标签信息";
      this.isShow = false;
      this.showModal = true;
      this.$store
        .dispatch("SelectSyslabInfo", { id: rowData.id })
        .then(async res => {
          console.log('resss',res)
          if (res.code == 0) {
            let obj = {};
            obj = Object.assign({}, res.sysLab);
            // obj.parentLabEntityList = obj.parentLabEntityList;
            let arr
            let arr1
            let arr2
            if(rowData.parentLabs)
            arr = rowData.parentLabs.split(',')
            if(rowData.parentName)
            arr1 = rowData.parentName.split(',')
            if(rowData.ids)
            arr2 = rowData.ids.split(',')
            if(rowData.parentLabs && rowData.parentName && rowData.ids)
            arr.forEach((item,index)=>{
              if(arr2 && arr && arr1)
              this.tabArr.push({'id':arr2[index],'parentId':arr[index],'labId':rowData.id,'labName':arr1[index]})
            })
            let arr3
            let arr4
            let arr5
            if(rowData.relevanceIds)
            arr3 = rowData.relevanceIds.split(',')
            if(rowData.relevanceLabs)
            arr4 = rowData.relevanceLabs.split(',')
            // if(rowData.ids)
            // arr5 = rowData.ids.split(',')
            if(rowData.relevanceIds && rowData.relevanceLabs)
            arr3.forEach((item,index)=>{
              if(arr2 && arr3 && arr4)
              this.tabArr1.push({'id':arr2[index],'relevanceLabId':arr3[index],'labName':arr4[index]})
            })
            if(rowData.type == 1){
              this.showCompany = true
            }else{
              this.showCompany = false
            }
            // this.tabArr = obj.parentLabEntityList;
            // obj.parentId = Number(obj.parentId);
            obj.type = obj.type;
            obj.deleted = obj.deleted;
            console.log('rowData.investments',rowData.investments)
            obj.investments = rowData.investments
            if(rowData.investments >= 10000 && rowData.investments < 100000000){
              this.investments = rowData.investments / 10000 
              // console.log('obj.investments',obj.investments)
              this.Measure = 10000
            }else if(rowData.investments >= 100000000){
              this.investments = rowData.investments / 100000000
              this.Measure = 100000000
            }else{
              this.investments = rowData.investments
              this.Measure = 1
            }
            if(!rowData.initNumber){
              obj.initNumber = 0
            }
            obj.initNumber = rowData.initNumber
            // 模拟attachmenCode
            if(!obj.attachmentCode){
              await getAttachmentCode().then((res)=>{
                // this.attachmentCode = res
                obj.attachmentCode = res
              })
            }
            // // 模拟attachmenCode
            // if(!obj.shareAttachmentCode){
            //   await getAttachmentCode().then((res)=>{
            //     // this.attachmentCode = res
            //     obj.shareAttachmentCode = res
            //     console.log('share',obj.shareAttachmentCode)
            //   })
            // }
            if(rowData.comCreateTime)
            obj.comCreateTime = rowData.comCreateTime.substr(0,10)
            if(rowData.companyName)
            obj.companyName = rowData.companyName
            if(!rowData.companyName)
            obj.companyName = ''
            this.tabInfo = obj;
            console.log('share1',this.tabInfo)
            this.getAttachment()
            // this.getAttachment1()
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
          console.log('err',err)
        });
    },
    async getAttachment(){
      let res = await getAttachmentList({attachmentCode:this.tabInfo.attachmentCode})
      if(res){
        console.log('res',res)
        if(res.code == 0){
          if(res.data.length!=0)
          if(res.data[0].ossUrl){
            res.data[0].url = res.data[0].ossUrl;
            this.imgUrl = [res.data[0]]
          }
          
          console.log('this')
        }
      }
    },
    // 查看
    handleShow(rowData) {
      this.title = "新闻订阅标签信息";
      this.isShow = true;
      this.showModal = true; 
      this.$store
        .dispatch("SelectSyslabInfo", { id: rowData.id })
        .then(res => {
          if (res.code === 0) {
            let obj = {};
            obj = Object.assign({}, res.sysLab);
            let arr
            let arr1
            if(rowData.parentLabs)
            arr = rowData.parentLabs.split(',')
            if(rowData.parentName)
            arr1 = rowData.parentName.split(',')
            if(rowData.parentLabs && rowData.parentName)
            arr.forEach((item,index)=>{
              this.tabArr.push({'id':rowData.labId,'parentId':arr[index],'labId':rowData.id,'labName':arr1[index]})
            })
            let arr3
            let arr4
            let arr5
            if(rowData.relevanceIds)
            arr3 = rowData.relevanceIds.split(',')
            if(rowData.relevanceLabs)
            arr4 = rowData.relevanceLabs.split(',')
            if(rowData.relevanceIds && rowData.relevanceLabs)
            arr3.forEach((item,index)=>{
              this.tabArr1.push({'relevanceLabId':arr3[index],'labName':arr4[index]})
            })
            if(rowData.type == 1){
              this.showCompany = true
            }else{
              this.showCompany = false
            }
            obj.type = Number(obj.type);
            obj.deleted = Number(obj.deleted);
            obj.investments = rowData.investments
            if(rowData.investments >= 10000 && rowData.investments < 100000000){
              this.investments = rowData.investments / 10000
              this.Measure = 10000
            }else if(rowData.investments >= 100000000){
              this.investments = rowData.investments / 100000000
              this.Measure = 100000000
            }else{
              this.investments = rowData.investments
              this.Measure = 1
            }
            if(!obj.initNumber){
              obj.initNumber = 0
            }
            if(rowData.comCreateTime)
            obj.comCreateTime = rowData.comCreateTime.substr(0,10)
            if(rowData.companyName)
            obj.companyName = rowData.companyName
            this.tabInfo = obj;
            this.getAttachment()
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
          console.log('err',err)
        });
    },
    ///////////////////////////////////////

    // 取消
    handleCancle() {
      this.showModal = false;
      this.$refs.labForm.resetFields();
      this.temp();
    },

    // 删除多条数据
    handleAllDel() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      if (this.selectRowIds.length === 0) {
        this.$message.warning("请先选择数据，在进行批量删除操作");
        return false;
      }
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      Modal.confirm({
        title: "确认批量删除",
        icon: createVNode(ExclamationCircleOutlined),
        content: "删除操作不可撤销，请谨慎操作。",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          self.$store
            .dispatch("DeleteSyslab", self.selectRowIds.join(","))
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: "已删除"
                });
                self.selectRowIds = "";
                self.getList();
              } else {
                self.$handleErr(res);
              }
            })
            .catch(err => {
              self.$handleErr(err);
            });
        },
        onCancel() {
          console.log("...");
        }
      });
    },
    // 分页、排序、筛选变化时触发
    changeTable(pagination, filters, sorter) {
      this.listQuery.pageIndex = pagination.current;
      this.listQuery.pageSize = pagination.pageSize;
      this.getList();
    },
    // 过滤搜索
    filterOption(input, option) {
      console.log("filterOption",input);
      return (
        option.children[0].children
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.picRemark{
  display:-webkit-box;
  overflow: hidden;
  white-space: normal !important;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical
  }
</style>
